//操作员接口
import operatorApi from "@api/operator";
//业务接口
import userApi from '@api/user'
import homeApi from '@api/home'
import deviceApi from '@api/device'
import shopApi from '@api/shop'
import firmwareApi from '@api/firmware'
import pluginApi from '@api/plugin'
import smsApi from '@api/sms'
import billApi from '@api/bill'
import logApi from '@api/log'
import portalApi from '@api/portal'
import domainApi from '@api/domain'
import permissionApi from '@api/permission'

export default {
  ...operatorApi,
  ...homeApi,
  ...userApi,
  ...deviceApi,
  ...shopApi,
  ...firmwareApi,
  ...pluginApi,
  ...smsApi,
  ...billApi,
  ...logApi,
  ...portalApi,
  ...domainApi,
  ...permissionApi
};
